import React from "react"
import { Box, CardMedia } from "@mui/material"
import Loader from "./assets/images"
import { makeStyles } from "tss-react/mui"

interface MpLoaderProps {
  height?: string
  width?: string
  marginTop?: string
}
const useStyles = makeStyles<MpLoaderProps>()(({ breakpoints }, props) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    marginTop: props.marginTop ?? "calc(100vh - 85vh)"
  },
  media: {
    height: props.height ? `${props.height}rem` : "9.5rem",
    width: props.width ? `${props.width}rem` : "16rem",
    [breakpoints.down("lg")]: {
      height: props.height ? `${props.height}rem` : "6rem",
      width: props.width ? `${props.width}rem` : "10rem"
    },
    [breakpoints.down("md")]: {
      height: props.height ? `${props.height}rem` : "4rem",
      width: props.width ? `${props.width}rem` : "7rem"
    }
  }
}))

const MpLoader: React.FC<React.PropsWithChildren<MpLoaderProps>> = ({
  ...props
}) => {
  const { classes } = useStyles(props)
  return (
    <Box className={classes.root}>
      <CardMedia
        className={classes.media}
        image={Loader.mp_loader}
        title="Loader"
      />
    </Box>
  )
}
export default MpLoader
